import React, {useContext, useState} from 'react'
import { Button, Col, Row } from "antd";
import {RecipeConText} from "../../../../context/RecipeContext";
import {createRecipe} from "../../../../services/serviceRecipe";
import {enterLoadingState, exitLoadingState} from "../../../../utils/helpers/commonFunctions";

const RecipeAbstract = () => {
    const {
        recipeAbstract,
        recipeTotal,
        rowData,
        productionData,
    } = useContext(RecipeConText)
    const [loadings, setLoadings] = useState([])

    const [abstractState] = recipeAbstract
    const [rowState] = rowData
    const [productionCosts] = productionData

    const handleSubmit = () => {
        enterLoadingState(setLoadings)
        let mockIngredients = Object.assign({}, rowState)
        let billOfMaterials = Object.keys(mockIngredients).map(key => {
            let item = mockIngredients[key]

            return {
                parity: item.parity,
                unitPrice: item.data.price,
                amount: item.quantity,
                lineTotal: (item.quantity * item.parity * item.data.price),
                stock: {
                    id: item.data.id
                }
            }
        })

        const recipe = {
            name: abstractState.name,
            code: abstractState.recipeCode,
            description: abstractState.description,
            imageUrl: abstractState.imageUrl ? abstractState.imageUrl : '',
            stockCode: abstractState.name,
            price: recipeTotal
        }

        let recipeProductionCosts = Object.keys(productionCosts).map(key => {
            const item = productionCosts[key]

            return{
                costName: item.name,
                ratio: item.ratio
            }
        })

        const requestObj = {
            billOfMaterials,
            recipe,
            recipeProductionCosts
        }

        createRecipe(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setTimeout(() => window.location = '/landing/recipe', 500)
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
                <Row>
                    <Col span={24}>
                        <h6 > Reçete Adı : </h6>
                    </Col>
                    <Col span={24}>
                        <span>{abstractState.name}</span>
                    </Col>
                    <Col span={24}>
                        <h6>Reçete Kodu :</h6>
                    </Col>
                    <Col span={24}>
                        <span>{abstractState.code}</span>
                    </Col>
                    <Col span={24}>
                        <h6>Toplam :</h6>
                    </Col>
                    <Col span={24}>
                        {
                          <p><span>{new Intl.NumberFormat().format(recipeTotal)} USD</span></p>
                        }
                    </Col>
                </Row>
                <Row justify={'end'}>
                    <Col>
                        <Button type={'primary'} loading={loadings[0]} onClick={handleSubmit} >Kaydet</Button>
                    </Col>
                </Row>
        </React.Fragment>
    )
}
export default RecipeAbstract